<script lang="ts" setup>

import userStore from '@/store/UserStore.ts'

const emit = defineEmits(['closeClicked'])

function openSurvey() {
  window.open(`${userStore.feedbackSurveyLink}${userStore.currentIsoLocale.split('-')[0]}`, '_blank')

  emit('closeClicked')
}
</script>

<template>
  <div class="survey__wrapper">
    <div class="survey__title">
      {{ $t('feedback_survey.title') }}
    </div>
    <div class="survey__description">
      {{ $t('feedback_survey.description') }}
    </div>
    <button class="survey__button btn" @click="openSurvey">
      {{ $t('feedback_survey.btn') }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
.survey {
  &__wrapper {
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: $textColorLight;
    padding: 1rem;

    @include themify($themes) {
      border-radius: rem-calc(themed('cardBorderRadius'));
    }

    .theme-va & {
      background: $vaPrimaryLightBackgroundColor;
    }

    .theme-sd & {
      background: $sdPrimaryLightBackgroundColor;
      border-radius: 10px;
    }
  }

  &__title {
    text-align: center;
    font-weight: bold;
    color: $textColor;

    .theme-va & {
      color: $vaPrimaryColor;
    }

    .theme-sd & {
      color: $sdSecondaryColor;
    }
  }

  &__description {
    text-align: center;
    margin-top: 0.5rem;
  }

  &__button {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    margin-top: 1rem;

    .theme-va & {
      background: $vaPrimaryColor;
      border: 0;
    }

    .theme-sd & {
      background: $sdSecondaryColor;
      border-radius: 0.25rem
    }

    &:hover {
      .theme-va & {
        background: $vaPrimaryHoverColor;
        border: 0;
      }

      .theme-sd & {
        background: $sdHoverColor;
      }

      cursor: pointer;

    }
  }
}
</style>
